var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleLayout',{attrs:{"is-cookie-bar-visible":false,"is-application-bar-visibile":false},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('HeaderGoodhome')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }